import { useEditorProgramIsTemplateQuery } from "../../../../graphql/graphqlGeneratedTypes/graphqlClient";
import { useEditorProgramId } from "../UseEditorProgramId";

export type UseEditorProgramIsTemplate = {
    isProgramTemplate: boolean | null;
};

export const useEditorProgramIsTemplate = (): UseEditorProgramIsTemplate => {
    const programId = useEditorProgramId();
    const { data } = useEditorProgramIsTemplateQuery({
        variables: { programId },
        skip: !programId
    });
    
    const isProgramTemplate = data?.editorProgram?.isTemplate ?? null;
    
    return {
        isProgramTemplate
    };
}; 
